import { Injectable } from '@angular/core';

@Injectable(
    {
        providedIn: null
    })
export class HighlightService {
    highlightThreshold: number = 15;

    constructor() { }

    //-- Project Note Highlight ------------------------------------------------
    // Although there are entries in the template, I am not sure 
    // this is valid or needed
    private dateDiff(startDate, endDate) {
        return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
    }

    private projectCreatedWithinThreshold(dateCreated, dateUpdated, threshold) {
        return (this.dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
    }

    private projectUpdatedWithinThreshold(dateUpdated, threshold) {
        return (this.dateDiff(dateUpdated, new Date()) < threshold);
    }

    class(created, updated) {
        created = new Date(created);
        updated = new Date(updated);

        if (this.projectCreatedWithinThreshold(created, updated, this.highlightThreshold)) return "created";
        if (this.projectUpdatedWithinThreshold(updated, this.highlightThreshold)) return "updated";

        return "";
    }

}
